// Ressources dont le calcul d'impact CO2 nécessite le poids de l'objet (facteur ADEME
// en kg/tonne plutôt que par unité). Doit rester synchronisé avec
// RESSOURCES_REQUIRING_WEIGHT dans boldeeback/config/co2Factors.js.
const RessourcesRequiringWeight = [
    'machines_industrielles',
    'equipements_production',
    'machines_outils',
    'chambre_froide',
    'lignes_production',
    'equipements_agricoles',
    'equipements_btp',
    'imprimantes_3d',
    'equipements_nettoyage',
    'bureaux_chaises_armoires',
    'cloisons_cabines',
    'rayonnages_etageres',
    'comptoirs_stands',
    'mobilier_stockage',
    'vehicules_utilitaires',
    'camions_remorques',
    'chariots_elevateurs',
    'transpalettes',
];

export default RessourcesRequiringWeight;
